export default {
      id: "spin-control-overlay-usage",
      viewBox: "0 0 480.23 480.21",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#spin-control-overlay-usage",
      toString: function () {
        return this.url;
      }
    }